import ApplicationResource from "../../utils/resources.enum";
import {FeaturedPlayListOutlined} from "@material-ui/icons";
import {QuizAssessmentAvailabilityList} from "./quiz-assessment-availability.list";
import {QuizAssessmentAvailabilityCreate} from "./quiz-assessment-availability.create";
import {QuizAssessmentAvailabilityEdit} from "./quiz-assessment-availability.edit";
import { Route } from "react-router-dom";
import {QuizAssessmentResultsPage} from "./pages/quiz-assessment-results";
import {MQuizAssessmentSaveResult} from "./pages/m-quiz-assessment-save-result";

const path = '/quiz-assessment-availability'
export const quizAssessmentQuestionAvailability = {
  name: ApplicationResource.QUIZ_ASSESSMENT_AVAILABILITY,
  icon: FeaturedPlayListOutlined,
  options: { label: "Avaliações" },
  link: path,
  tableName: 'quiz-assessment-availability',
  list: QuizAssessmentAvailabilityList,
  edit: QuizAssessmentAvailabilityEdit,
  create: QuizAssessmentAvailabilityCreate,
  products: ['quiz'],
  routes: [
    <Route exact path={`${path}/results/save-results-mobile`} key={`${path}/results/save-results-mobile`} component={MQuizAssessmentSaveResult} />,
    <Route exact path={`${path}/results/:testId`} key={`${path}/results`} component={QuizAssessmentResultsPage} />,
  ],
}